import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ngb-txoamonitor-edit-modal-content',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{name}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <div class="in-line">
            <label for="InputDeviceName">Device:</label>            
          </div>
          <input type="text" class="form-control" id="InputDeviceName" aria-describedby="deviceNameHelp" placeholder="Enter Device Name" value={{device.device}}>
        </div>       
        <div class="form-group">
          <label for="InputTransmitterCode">Transmitter Code:</label>
          <input type="text" class="form-control" id="InputTransmitterCode" placeholder="Enter Transmitter Code" value={{device.transmitterCode}}>
        </div>
        <div class="form-group">
          <label for="InputTimeOut">Time-out:</label>
          <input type="text" class="form-control" id="InputTimeOut" placeholder="Enter Time-out" value={{device.timeout}}>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Save</button>
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Cancel click')">Cancel</button>
    </div>  `
})
export class NgbTxoamonitorEditModalContent {
  @Input() name;
  @Input() device;

  constructor(public activeModal: NgbActiveModal) { }
}
